export default __webpack_public_path__ + "static/media/bernay14.75cd50e6.jpg";